module.exports = __webpack_public_path__ + "images/emoji/ski.330c4b5de0b8d6f9f779.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ski.png
// module id = Otoh
// module chunks = 14